<template>
    <div
id="addonsModal" ref="addonsModal" class="modal fade" tabindex="-1" aria-labelledby="addonsModal"
        aria-hidden="true"
>
        <div
            class="modal-dialog modal-dialog-centered mobile:!px-3 tablet:!px-0 mobile:!max-w-full tablet:!w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full"
>
            <div class="modal-content">
                <div class="modal-body !p-3 !pb-5">
                    <div class="relative">
                        <button
type="button"
                            class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
                            data-bs-dismiss="modal" aria-label="Close"
>
                            <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
                        </button>
                        <div class="relative rounded-lg overflow-hidden h-[100px]">
                            <img
src="../../../assets/images/profile-bg.png" alt="Background"
                                class="w-full h-auto object-cover"
>
                            <div class="flex items-center gap-1 p-3 absolute top-0 left-0 w-full h-full">
                                <img
src="../../../assets/images/addons-modal-icon.svg" alt="Addons Modal Icon"
                                    class="w-[30px] h-[30px] object-cover"
>
                                <h4 class="text-xl m-0 font-roboto font-bold text-gray-800">
                                    Optional Coverages
                                </h4>
                            </div>
                        </div>
                    </div>
                    <div class="h-[80vh] overflow-y-auto customScrollbar mt-3">
                        <p class="my-[20px] text-[14px] font-roboto text-[#666666]">
Lorem ipsum dolor sit amet,
                            consectetur
                            adipiscing elit. Fusce tincidunt tristique tincidunt.
                            Donec fermentum mi et ipsum cursus mollis. Suspendisse eget massa fringilla, scelerisque
                            lectus ac, semper nunc.
</p>
                        <div
v-for="data in addOnData" :key="data"
                            class="py-[10px] px-[5px] flex flex-col gap-[5px] border-b border-[#EFEFEF]"
>
                            <div class="flex items-center justify-between">
                                <label class="flex items-center gap-2 cursor-pointer select-none">
                                    <input
v-model="data.checked" type="checkbox" class="hidden peer"
                                        @click="onCheckboxClick(data)"
>
                                    <div
                                        class="w-[30px] h-[30px] rounded-[5px] flex items-center justify-center transition border border-[#CCCCCC] peer-checked:!border-[#A084E8]"
>
                                        <svg
v-if="data.checked" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                            fill="#A084E8" class="w-[20px] h-[20px]"
>
                                            <path
fill-rule="evenodd"
                                                d="M16.707 5.293a1 1 0 0 1 0 1.414l-7.5 7.5a1 1 0 0 1-1.414 0l-3.5-3.5a1 1 0 1 1 1.414-1.414L8.5 11.086l6.793-6.793a1 1 0 0 1 1.414 0z"
                                                clip-rule="evenodd"
/>
                                        </svg>
                                    </div>
                                    <span class="text-[14px] font-roboto text-[#333]">
                                        {{ data.bundle_name }}
                                    </span>
                                </label>
                                <div>
                                    <h6 class="m-0 text-[14px] text-[#EA8A8A]">
{{ data.months }} months plan
</h6>
                                    <h2 class="m-0 text-[18px] font-bold font-roboto text-[#333]">
${{
                                        $helper.formatAmount(data.amount) }}/mo
                                    </h2>
                                </div>
                            </div>
                            <div class="flex items-end justify-between">
                                <quantityCounter
v-if="((data.is_show_quantity == '1'))" class="w-max"
                                    :quantity="data.quantity" :product="data" :disabled="data.quantity <= 0"
                                    @update-counter="updateCounter"
/>
                                <h2
v-if="data.checked && data.quantity > 1"
                                    class="m-0 text-[16px] font-bold font-roboto text-[#9C9BBF]"
>
${{
                                        $helper.formatAmount(data.amount * data.quantity) }}/mo
                                </h2>
                            </div>
                        </div>
                        <div v-if="!isFromCheckout" class="flex items-center justify-center gap-[10px] mt-4">
                            <!-- <button @click="skipClicked"
                                class="px-[30px] py-[6px] text-[14px] rounded-[5px] border-[1px] border-[#A084E8] text-[#A084E8]"
                                data-bs-dismiss="modal">
                                Skip
                            </button> -->
                            <button
class="px-[30px] py-[6px] text-[14px] rounded-[5px] border-[1px] border-[#29C6CD] text-[#29C6CD]"
                                @click="checkoutclicked"
>
                                Proceed to Checkout
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap";
import quantityCounter from "../../partialComponent/quantityCounter.vue";
import { mapActions, mapGetters } from "vuex";


export default {
    components: {
        quantityCounter
    },
    props: {
        bundle: Object,
        updateCart: Function,
        isFromCheckout: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            checked: false,
            route_slug: 'add-on',
            addOnData: [],
            isCartUpdated: false
        };
    },

    computed: {
        ...mapGetters([
            "protectionPlanBundleAddons",
            "selectedProtectionPlan",
            "cartUpdated"
        ]),

    },
    watch: {
        protectionPlanBundleAddons: function (data) {
            const updatedBundles = data.map(bundle => ({
                ...bundle,
                checked: bundle.quantity > 0
            }));

            this.isCartUpdated = false
            this.addOnData = updatedBundles
            if (this.modal) {
                if (window.innerWidth > 992) {
                    document.documentElement.classList.add("overflow-hidden");
                }
                this.modal.show();
            }

        },

        cartUpdated: function (data) {
            this.isCartUpdated = true
            this.getProtectionPlansBundleAddons({ 'partner_id': this.selectedProtectionPlan.partner_id, "route_slug": this.route_slug });

        },

    },

    mounted() {

    },

    methods: {

        ...mapActions([
            "getProtectionPlansBundleAddons",
            "upsertCart",

        ]),

        onCheckboxClick(data) {
            data.checked = !data.checked;


            this.upsertCart({
                "bundle_id": data.id,
                "quantity": data.checked ? 1 : 0,
                "partner_id": data.partner_id ? data.partner_id : this.selectedProtectionPlan.partner_id
            })
        },

        openModal() {
            const modalEl = this.$refs.addonsModal;

            // Create bootstrap modal
            this.modal = new Modal(modalEl, { backdrop: 'static' });

            // Fix scroll restore on close
            modalEl.addEventListener("hidden.bs.modal", () => {
                document.documentElement.classList.remove("overflow-hidden");
                this.modal = null
            });
            this.getProtectionPlansBundleAddons({ 'partner_id': this.selectedProtectionPlan.partner_id, "route_slug": this.route_slug });
            // Tailwind way → disable scroll

        },

        closeModal() {
            // Tailwind way → enable scroll
            if (window.innerWidth > 992) {
                document.documentElement.classList.remove("overflow-hidden");
            }
            this.modal.hide();
        },

        updateCounter(option, data) {

            let quantity = data?.quantity ?? 0

            if (option == "increment") {

                quantity = quantity + 1

            } else if (option == "decrement" || option == "remove") {

                quantity = quantity - 1

                if (quantity <= 0) {
                    quantity = 0
                }
            }

            this.upsertCart({
                "bundle_id": data.id,
                "quantity": quantity,
                "partner_id": data.partner_id ? data.partner_id : this.selectedProtectionPlan.partner_id
            })
        },

        checkoutclicked() {
            this.$router.push({
                name: 'partnerCheckout'
            })
        }

    },
};
</script>
